import { createSelector } from "@reduxjs/toolkit";
import { MainFilters } from "../../types/state";
import { RootState } from "src/store/rootReducer";
import { NameSpace } from "../../const";

export const getFilters = createSelector(
  (state: RootState) => state.gop[NameSpace.FiltersMain],
  (state: MainFilters) => state.data
);

export const getFetchingStatusFilters = createSelector(
  (state: RootState) => state.gop[NameSpace.FiltersMain],
  (state: MainFilters) => state.fetchingStatusFilters
);
